import { useDispatch, useSelector } from "react-redux";
import { useCallback } from 'react';
import {
  createSplitShip,
  reopenSplitShip,
  resetSplitShip,
  retrieveSplitShip,
  selectSplitShipAccessible,
  deleteSplitShip,
  updateExternalSku,
  getErrors,
  getBatchErrors,
  toggleSummarizeTaxes,
} from "../../redux/splitShip";

export function useSplitShip(order_id: string) {
  const dispatch = useDispatch();

  const accessible = useSelector((state: any) =>
    selectSplitShipAccessible(state),
  );

  const handleCreateSplitShip = () => {
    if (order_id) {
      dispatch(createSplitShip(order_id) as any);
    }
  };

  const handleReopenSplitShip = () => {
    if (order_id) {
      dispatch(reopenSplitShip(order_id) as any);
    }
  };

  const handleResetSplitShip = () => {
    if (order_id) {
      dispatch(resetSplitShip(order_id) as any);
    }
  };

  const handleRetrieveSplitShip = useCallback(() => {
    if (order_id) {
      dispatch(retrieveSplitShip(order_id) as any);
    }
  }, [dispatch, order_id]);

  const handleDeleteSplitShip = () => {
    if (order_id) {
      dispatch(deleteSplitShip(order_id) as any);
    }
  };
  const handleUpdateExternalSku = (splitShipId: string, breakdownId: string, value: string) => {
    dispatch(updateExternalSku({ orderId: order_id, splitShipId, breakdownId, value }) as any);
  };

  const handleToggleSummarizeTaxes = (splitShipId: string) => {
    dispatch(toggleSummarizeTaxes({ splitShipId }) as any);
  };

  const handleGetError = (splitShipId: string) => {
    dispatch(getErrors({ splitShipId }) as any);
  };

  const handleGetBatchErrors = (splitShipId: string) => {
    dispatch(getBatchErrors({ splitShipId }) as any);
  };

  return {
    accessible,
    createSplitShip: handleCreateSplitShip,
    resetSplitShip: handleResetSplitShip,
    reopenSplitShip: handleReopenSplitShip,
    deleteSplitShip: handleDeleteSplitShip,
    retrieveSplitShip: handleRetrieveSplitShip,
    getError: handleGetError,
    getBatchErrors: handleGetBatchErrors,
    updateExternalSku: handleUpdateExternalSku,
    toggleSummarizeTaxes: handleToggleSummarizeTaxes,
  };
}
